/**
 * Verrou de defilement du <body> partage par les fenetres superposees.
 *
 * Chaque fenetre posait `overflow: hidden` et remettait `''` en se fermant :
 * deux fenetres ouvertes l'une sur l'autre, la premiere fermee rendait le
 * defilement a la page alors que la seconde etait encore affichee (SC-1092 :
 * l'annonce du restaurant s'ouvre par-dessus la question « A emporter ou
 * Livraison ? », qui ne se ferme pas sans reponse). Le verrou compte ses
 * detenteurs et ne rend le defilement qu'au dernier.
 */
let holders = 0;

export function lockBodyScroll(): () => void {
  holders += 1;
  document.body.style.overflow = 'hidden';
  let released = false;
  return () => {
    if (released) return;
    released = true;
    holders -= 1;
    if (holders === 0) document.body.style.overflow = '';
  };
}
